import { Role, UserInsuranceProduct } from 'src/app/interfaces/api';
import { SocialUser } from '@abacritt/angularx-social-login';
import { Residence } from './residence.model';
import { University } from './university.model';

export class User {
  // user might be email registered, and so have uuid and pw, or might be social registered, and have the equivalent
  uuid: string | undefined;

  password: string | undefined;

  socialUserId: string | undefined;

  socialToken: string | undefined;

  acceptedEmail!: boolean | undefined | null;

  allowEmail!: boolean | undefined | null;

  acceptedNotifications!: boolean | undefined | null;

  allowNotifications!: boolean | undefined | null;

  email!: string | undefined;

  emailVerifiedAt!: string | undefined;

  firstName!: string | undefined;

  lastName!: string | undefined;

  universityId!: string | undefined | null;

  accommodationId!: string | undefined | null;

  cityId!: string;

  dob!: Date | undefined;

  university!: University;

  accommodation!: Residence;

  method!: string; // which type of social login (if any) they've used

  confirmedCover!: boolean | null | undefined;

  onboarded!: boolean | null | undefined;

  expoToken!: string | null | undefined;

  registrationMethod: string | undefined;

  registrationPlatform: string | undefined;

  insuranceProducts: UserInsuranceProduct[] | undefined;

  coverCount: number | undefined;

  acceptedTracking: boolean | undefined;

  ssoProvider!: string;

  coveredError: boolean = false;

  wellbeingError: boolean = false;

  referrer!: string;

  roles: Role[] = [];

  recaptchaToken: string = '';

  postcode?: string = '';

  isAbove17?: boolean = false;

  public hasRole(role: string): boolean {
    return Boolean(this.roles.find((r) => r.name === role));
  }

  /**
   * Put user from a json user
   * @param json
   * @returns User
   */
  public static fromJson(json: User): User {
    const user = new User();
    user.uuid = json.uuid;
    user.acceptedEmail = json.acceptedEmail ?? null;
    user.allowEmail = json.allowEmail ?? null;
    user.acceptedNotifications = user.acceptedNotifications ?? null;
    user.allowNotifications = user.allowNotifications ?? null;
    user.email = json.email;
    user.emailVerifiedAt = json.emailVerifiedAt;
    user.dob = json.dob;
    user.isAbove17 = json.isAbove17;
    user.firstName = json.firstName;
    user.lastName = json.lastName;
    user.onboarded = json.onboarded;
    user.accommodationId = json.accommodation?.uuid ?? null;
    user.expoToken = json.expoToken ?? null;
    user.universityId = json.university?.uuid ?? null;
    user.confirmedCover = json.confirmedCover;
    user.registrationMethod = json.registrationMethod;
    user.registrationPlatform = json.registrationPlatform;
    user.coverCount = json.coverCount;
    user.acceptedTracking = json.acceptedTracking;
    user.ssoProvider = json.ssoProvider;
    user.roles = json.roles;
    user.postcode = json.postcode;

    return user;
  }

  /**
   * Put social user data into a user object
   * @param socialUser
   * @param platform
   * @returns User
   */
  public static fromSocialUser(socialUser: SocialUser, platform: string): User {
    const user = new User();
    user.method = platform;
    user.socialUserId = socialUser.id ?? undefined;
    user.socialToken = socialUser.authToken;
    user.firstName = socialUser.firstName ?? undefined;
    user.lastName = socialUser.lastName ?? undefined;
    user.email = socialUser.email ?? undefined;
    return user;
  }
}
